<template>
    <v-container fluid class="incidente-root">
        <div>
            <h2>Actualización masiva de correos</h2>
            <v-card>
                <v-card-title class="d-flex align-center">
                    <v-icon left color="primary">mdi-email-sync-outline</v-icon>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text>
                    <v-alert type="info" outlined dense>
                        El archivo debe contener únicamente las columnas:
                        <b>Documento</b> y <b>Correo</b>. El correo debe terminar en
                        <b>@policia.bo</b>.
                    </v-alert>

                    <v-file-input v-model="archivo" label="Seleccionar archivo Excel" accept=".xlsx,.xls" prepend-icon="mdi-file-excel" outlined
                        dense :disabled="validando || importando" @change="limpiarResultado" />
                    <v-row class="mt-2">
                        <v-col cols="12" md="4">
                            <v-btn class="perfil-btn-primary" block :loading="validando" :disabled="!archivo || importando" @click="validarExcel">
                                <v-icon left>mdi-check-circle-outline</v-icon>Validar archivo
                            </v-btn>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-btn class="perfil-btn-primary" block :loading="importando" :disabled="!puedeImportar" @click="confirmDialog = true">
                                <v-icon left>mdi-upload</v-icon>
                                Actualizar correos
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-row v-if="resultado" class="mt-4">
                        <v-col cols="12" md="4">
                            <v-card outlined>
                                <v-card-text class="text-center">
                                    <div class="text-h5 font-weight-bold">{{ resultado.total }}</div>
                                    <div>Total registros</div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-card outlined>
                                <v-card-text class="text-center success--text">
                                    <div class="text-h5 font-weight-bold">{{ resultado.validos }}</div>
                                    <div>Válidos</div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-card outlined>
                                <v-card-text class="text-center error--text">
                                    <div class="text-h5 font-weight-bold">{{ resultado.errores }}</div>
                                    <div>Con errores</div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>

                    <v-alert v-if="resultado && resultado.inconsistencias && resultado.inconsistencias.length" type="error" outlined dense class="mt-4">
                        El archivo tiene inconsistencias. Corrige los errores antes de importar.
                    </v-alert>
                    <v-data-table v-if="resultado && resultado.inconsistencias && resultado.inconsistencias.length" :headers="headersErrores"
                        :items="resultado.inconsistencias" dense class="mt-3" :items-per-page="10" />
                    <v-data-table v-if="resultado && resultado.filasValidas && resultado.filasValidas.length" :headers="headersPreview"
                        :items="resultado.filasValidas" dense class="mt-4" :items-per-page="10">
                        <template v-slot:top>
                            <h3 class="subtitle-1 font-weight-bold mb-2">
                                Vista previa de correos válidos
                            </h3>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>

            <v-dialog v-model="confirmDialog" max-width="460" persistent>
                <v-card class="text-center pa-6">
                    <v-icon color="orange lighten-1" size="72" class="mb-4">
                        mdi-alert-circle-outline
                    </v-icon>

                    <div class="text-h5 font-weight-bold mb-3">
                        Confirmar actualización
                    </div>

                    <div class="grey--text text--darken-1 mb-5">
                        Se actualizarán
                        <b>{{ resultado ? resultado.validos : 0 }}</b>
                        correos institucionales.
                        <br>
                        Esta acción modificará únicamente el campo correo.
                    </div>

                    <v-row>
                        <v-col cols="6">
                            <v-btn block text @click="confirmDialog = false" :disabled="importando">
                                Cancelar
                            </v-btn>
                        </v-col>
                        <v-col cols="6">
                            <v-btn block color="success" :loading="importando" @click="importarExcel">
                                Confirmar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card>
            </v-dialog>

            <v-dialog v-model="procesandoDialog" persistent max-width="360">
                <v-card class="text-center pa-6">
                    <v-progress-circular indeterminate color="primary" size="54" />
                    <div class="mt-4 font-weight-bold">
                        Procesando archivo...
                    </div>
                    <div class="grey--text mt-1">
                        Por favor espera.
                    </div>
                </v-card>
            </v-dialog>

            <v-alert v-if="actualizacionExitosa" type="success" outlined class="mt-4">
                Se actualizaron correctamente los correos. Puede cargar un nuevo archivo.
            </v-alert>
        </div>
    </v-container>
</template>

<script>
import axios from 'axios';

export default {
    name: 'ImportarCorreosFuncionarios',

    props: {
        value: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            internalValue: false,
            archivo: null,
            resultado: null,
            validando: false,
            importando: false,
            confirmDialog: false,

            headersErrores: [
                { text: 'Fila', value: 'fila' },
                { text: 'Campo', value: 'campo' },
                { text: 'Valor', value: 'valor' },
                { text: 'Mensaje', value: 'mensaje' }
            ],

            headersPreview: [
                { text: 'Fila', value: 'filaExcel' },
                { text: 'Documento', value: 'documento' },
                { text: 'Correo', value: 'correo' }
            ],
            actualizacionExitosa: false,
        };
    },

    computed: {
        puedeImportar() {
            return (
                this.resultado &&
                this.resultado.filasValidas &&
                this.resultado.filasValidas.length > 0 &&
                (!this.resultado.inconsistencias || this.resultado.inconsistencias.length === 0) &&
                !this.validando &&
                !this.importando
            );
        },

        procesandoDialog() {
            return this.validando || this.importando;
        }
    },

    watch: {
        value(val) {
            this.internalValue = val;
        },

        internalValue(val) {
            this.$emit('input', val);
            if (!val) this.limpiarTodo();
        }
    },

    methods: {
        limpiarResultado() {
            this.resultado = null;
        },

        limpiarTodo() {
            this.archivo = null;
            this.resultado = null;
            this.validando = false;
            this.importando = false;
            this.confirmDialog = false;

            // reiniciar v-file-input
            this.$nextTick(() => {
                this.archivo = null;
            });
        },

        cerrar() {
            this.internalValue = false;
        },

        async validarExcel() {
            if (!this.archivo) return;

            this.validando = true;
            this.resultado = null;

            try {
                const formData = new FormData();
                formData.append('archivo', this.archivo);

                const response = await axios.post(
                    'api/PersonaInfoGenerals/ValidarExcelCorreosFuncionarios',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );

                this.resultado = response.data;

                if (this.resultado.errores > 0) {
                    this.$emit('error', 'El archivo tiene inconsistencias');
                } else {
                    this.$emit('success', 'Archivo validado correctamente');
                }
            } catch (error) {
                console.error(error);

                const mensaje =
                    error.response?.data?.message ||
                    error.response?.data?.error ||
                    'Error al validar el archivo';

                this.$emit('error', mensaje);
            } finally {
                this.validando = false;
            }
        },

        async importarExcel() {
            if (!this.puedeImportar) return;

            this.importando = true;

            try {
                await axios.post(
                    'api/PersonaInfoGenerals/ImportarExcelCorreosFuncionarios',
                    {
                        filas: this.resultado.filasValidas,
                        oid_user: Number(localStorage.getItem('oidu'))
                    }
                );

                this.$emit('success', 'Correos actualizados correctamente');

                // cerrar diálogo confirmación
                this.confirmDialog = false;

                // limpiar toda la pantalla
                this.actualizacionExitosa = true;
                this.limpiarTodo();

            } catch (error) {
                console.error(error);

                const mensaje =
                    error.response?.data?.message ||
                    error.response?.data?.error ||
                    'Error al actualizar correos';

                this.$emit('error', mensaje);
            } finally {
                this.importando = false;
            }
        }
    }
};
</script>